import React, { createContext, FC, useContext, useState, useCallback } from 'react'

interface ProjectLimitModalContextType {
  isProjectLimitModalOpen: boolean
  event?: string
  openProjectLimitModal: (event?: string) => void
  closeProjectLimitModal: () => void
}

const ProjectLimitModalContext = createContext<ProjectLimitModalContextType>({
  isProjectLimitModalOpen: false,
  event: undefined,
  openProjectLimitModal: () => {
    console.error('openProjectLimitModal function called before being initialized')
  },
  closeProjectLimitModal: () => {
    console.error('closeProjectLimitModal function called before being initialized')
  },
})

export const useProjectLimitModalContext = (): ProjectLimitModalContextType => {
  return useContext(ProjectLimitModalContext)
}

export const ProjectLimitModalContextProvider: FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isProjectLimitModalOpen, setIsProjectLimitModalOpen] = useState<boolean>(false)
  const [event, setEvent] = useState<string | undefined>(undefined)

  const openProjectLimitModal = useCallback((event?: string) => {
    setEvent(event)
    setIsProjectLimitModalOpen(true)
  }, [])

  const closeProjectLimitModal = useCallback(() => {
    setIsProjectLimitModalOpen(false)
    setEvent(undefined)
  }, [])

  return (
    <ProjectLimitModalContext.Provider
      value={{
        isProjectLimitModalOpen,
        openProjectLimitModal,
        closeProjectLimitModal,
        event,
      }}
    >
      {children}
    </ProjectLimitModalContext.Provider>
  )
}
